import invariant from 'invariant';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import { buildAffiliateContextAttribute } from '../utils';

export default function createFastUser(
    { baseUrl, brandId, clientId, country, firstName, gender, lastName, logonId, maMarketingConsent, maTrackingPartnerCode, personTitle, uberToken },
    excludePartnerizeAttribute,
) {
    invariant(baseUrl, 'baseUrl is a required param of createFastUser()');
    invariant(brandId, 'brandId is a required param of createFastUser()');
    invariant(country, 'country is a required param of createFastUser()');
    invariant(clientId, 'clientId is a required param of createFastUser()');
    invariant(logonId, 'logonId is a required param of createFastUser()');
    invariant(uberToken, 'uberToken is a required param of createFastUser()');
    invariant(maMarketingConsent, 'maMarketingConsent is a required param of createFastUser()');

    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/guestidentity/fastuser`;
    const headers = { 'Content-Type': 'application/json' };
    const body = {
        email: logonId,
        registrationSource: 'Web',
        ...(gender && { gender }),
        ...(personTitle && { personTitle }),
        ...(firstName && { firstName }),
        ...(lastName && { lastName }),
        updateSelfAddress: 'true',
        contextAttribute: [
            {
                attributeName: 'maMarketingConsent',
                attributeValue: {
                    value: maMarketingConsent,
                },
            },
            ...(maTrackingPartnerCode
                ? [
                      {
                          attributeName: 'maTrackingPartnerCode',
                          attributeValue: {
                              value: maTrackingPartnerCode,
                          },
                      },
                  ]
                : []),
            ...buildAffiliateContextAttribute(excludePartnerizeAttribute),
        ],
    };

    return labelRequest(authenticatedRequest(new Request(url, { headers, method: 'POST', body: JSON.stringify(body) }), uberToken, clientId), 'createFastUser');
}